// Copyright 2017 Sorama B.V.

export class Splice<T> {
    public index: number;
    public addedCount: number;
    public removed: T[];
}
